import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rounded-md border border-secondary-200" }
const _hoisted_2 = { class: "flex items-center justify-between gap-x-3 rounded-t-md border-b bg-secondary-50 p-4 font-medium" }
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = { class: "summary-container-content w-full divide-y-2 divide-dashed divide-gray-200" }

import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'
import type { RouteLocationRaw } from 'vue-router'

interface Props {
  /** The header text */
  header: string
  /** Optional route for edit link */
  route?: RouteLocationRaw | null
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'SummaryContainer'
},
  __name: 'SummaryContainer',
  props: {
    header: {},
    route: { default: null }
  },
  setup(__props: any) {





const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _renderSlot(_ctx.$slots, "heading", { header: __props.header }, () => [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.header), 1)
      ]),
      (__props.route)
        ? (_openBlock(), _createBlock(_unref(RouterLink), {
            key: 0,
            class: "text-primary",
            to: __props.route
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('general.edit')), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})